import { Pipe } from '@angular/core';
var SamplePipe = (function () {
    function SamplePipe() {
    }
    SamplePipe.prototype.transform = function (input, len) {
        if (len === void 0) { len = 1; }
        if (!Array.isArray(input)) {
            return input;
        }
        var sample = [];
        var tmp = input.slice();
        var l = len < tmp.length ? len : tmp.length;
        for (var i = 0; i < l; ++i) {
            sample = sample.concat(tmp.splice(Math.floor(Math.random() * tmp.length), 1));
        }
        return sample;
    };
    SamplePipe.decorators = [
        { type: Pipe, args: [{ name: 'sample' },] },
    ];
    /** @nocollapse */
    SamplePipe.ctorParameters = function () { return []; };
    return SamplePipe;
}());
export { SamplePipe };
//# sourceMappingURL=sample.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/sample.js
// module id = 231
// module chunks = 4